import {Button, Form, Input} from 'antd';
import PropTypes from 'prop-types';

const RegistrationForm = ({onSubmit, isLoading}) => {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      layout={'vertical'}
      onFinish={onSubmit}
      className={'w-full h-full'}
    >
      <div className={'flex justify-between gap-2'}>
        <Form.Item
          name={'firstName'}
          label={'First Name'}
          rules={[
            {required: true},
            {whitespace: true, message: ''},
            {pattern: /^[A-Za-z]+$/, message: 'Only letters are allowed'},
          ]}
          className={'w-full'}
        >
          <Input placeholder={'Enter your first name'} />
        </Form.Item>

        <Form.Item
          name={'lastName'}
          label={'Last Name'}
          rules={[
            {required: true},
            {whitespace: true, message: ''},
            {pattern: /^[A-Za-z]+$/, message: 'Only letters are allowed'},
          ]}
          className={'w-full'}
        >
          <Input placeholder={'Enter your last name'} />
        </Form.Item>
      </div>

      <div className={'flex justify-between gap-2'}>
        <Form.Item
          name={'mobile'}
          label={'Mobile Number'}
          rules={[
            {required: true, message: 'Mobile number is required'},
            {len: 10, message: 'Mobile must be 10 digits'},
          ]}
          normalize={value => value.replace(/\D/g, '').slice(0, 10)}
          className={'w-full'}
        >
          <Input maxLength={10} placeholder={'Enter mobile number'} />
        </Form.Item>

        <Form.Item
          name={'pinCode'}
          label={'Pincode'}
          rules={[
            {required: true, message: 'Pincode is required'},
            {len: 6, message: 'Pincode must be 6 digits'},
          ]}
          normalize={value => value.replace(/\D/g, '').slice(0, 6)}
          className={'w-full'}
        >
          <Input maxLength={6} placeholder={'Enter pincode'} />
        </Form.Item>
      </div>

      <div className={'flex justify-between gap-2'}>
        <Form.Item
          name={'email'}
          label={'Email'}
          rules={[
            {required: true, message: 'Email is required'},
            {type: 'email', message: 'Invalid email format'},
          ]}
          className={'w-full'}
        >
          <Input placeholder={'Enter your email'} />
        </Form.Item>

        <Form.Item
          name={'password'}
          label={'Password'}
          rules={[
            {required: true, message: 'Password is required'},
            {min: 6, message: 'Password must be at least 6 characters'},
          ]}
          className={'w-full'}
        >
          <Input.Password placeholder={'Enter password'} />
        </Form.Item>
      </div>

      <Form.Item
        name={'address'}
        label={'Address'}
        rules={[{required: true, message: 'Address cannot be empty'},
          {whitespace: true, message: 'Address cannot be empty'},
        ]}
      >
        <Input.TextArea rows={3} placeholder={'Enter address'} />
      </Form.Item>

      <Button
        type={'primary'}
        htmlType={'submit'}
        className={'bg-primary-800 text-white'}
        loading={isLoading}
      >
        Register
      </Button>
    </Form>
  );
};

RegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default RegistrationForm;
